import React from 'react';
import PriceUnit from 'components/ui/PriceUnit';
import formatNumber from 'utils/formatNumber';

import './Price.scss';

const Price = ({
  amount,
  unit,
  extraClassName,
  component: Component = 'span',
  ...restOfProps
}) => (
  <Component className={`price ${extraClassName}`} {...restOfProps}>
    <span className="price__amount" data-shmid="price-amount">
      {amount && formatNumber(amount)}
    </span>

    <span className="price__unit">
      <PriceUnit type={unit} />
    </span>
  </Component>
);

export default Price;
